import React from 'react';
import db from '../data/db.json';
import './About.css';

const About = () => {
  const { title, sections, team } = db.about;

  return (
    <div className="about">
      <section className="page-header">
        <div className="container">
          <h1 className="page-title">{title}</h1>
        </div>
      </section>

      <section className="about-content">
        <div className="container">
          {sections.map((section, index) => (
            <div key={index} className="about-section">
              <h2 className="section-heading">{section.heading}</h2>
              <p className="section-content">{section.content}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="team-section">
        <div className="container">
          <h2 className="section-title">Meet Our Team</h2>
          <div className="team-grid">
            {team.map((member, index) => (
              <div key={index} className="team-card">
                <div className="team-image">{member.image}</div>
                <h3 className="team-name">{member.name}</h3>
                <p className="team-role">{member.role}</p>
                <p className="team-bio">{member.bio}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;

